import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { COMPANY } from "../data/site";

export default function CTASection({
    eyebrow = "Request a Quote",
    title = "Let's Keep Your Freight Moving.",
    copy = "Tell us what you're moving and where it needs to go. Our team will help determine the right logistics solution.",
}) {
    return (
        <section className="relative overflow-hidden bg-ink grain" data-testid="cta-section">
            <div
                className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent"
                aria-hidden="true"
            />
            <div className="container-px relative py-20 lg:py-28 text-center">
                <Reveal>
                    <Eyebrow className="justify-center">{eyebrow}</Eyebrow>
                    <h2 className="mt-6 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
                        {title}
                    </h2>
                    <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-gray-400">
                        {copy}
                    </p>
                    <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                        <Link
                            to="/contact"
                            data-testid="cta-quote-button"
                            className="group inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-gold px-8 py-4 font-heading text-sm font-bold uppercase tracking-[0.14em] text-ink transition-colors duration-200 hover:bg-gold-light"
                        >
                            Request a Quote
                            <ArrowRight
                                size={16}
                                className="transition-transform duration-200 group-hover:translate-x-1"
                                aria-hidden="true"
                            />
                        </Link>
                        <a
                            href={COMPANY.phoneHref}
                            data-testid="cta-call-button"
                            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 border border-white/25 px-8 py-4 font-heading text-sm font-semibold uppercase tracking-[0.14em] text-white transition-colors duration-200 hover:border-gold hover:text-gold"
                        >
                            <Phone size={16} aria-hidden="true" />
                            Call Pacific Expressway
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
